import { signInWithPopup, signOut, signInWithEmailAndPassword } from 'firebase/auth';
import { auth, googleProvider } from '../firebase';

export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    return result.user;
  } catch (error) {
    console.error('Sign in error:', error);
    if (error.code === 'auth/configuration-not-found') {
      throw new Error('Google authentication is not properly configured. Please check Firebase setup.');
    }
    throw error;
  }
};

export const signOutOfAccount = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error('Sign out error:', error);
    throw error;
  }
};

export const signInWithEmail = async (email, password) => {
  try {
    const result = await signInWithEmailAndPassword(auth, email, password);
    return result.user;
  } catch (error) {
    console.error('Sign in error:', error);
    throw error;
  }
};
